import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { BsModalService } from 'ngx-bootstrap/modal'
import { EmpresaQueVendeComCartoes } from '../pkw-data/collect/empresa-que-vende-com-cartoes.model'
import { Empresa } from '../pkw-data/core/empresa.model'
import { ExportacaoMovimentoComponent } from './exportacao-movimento/exportacao-movimento.component'
import { GerarRelatorioModalComponent } from './relatorio/gerar-relatorio-modal/gerar-relatorio-modal.component'
import { DadosIniciaisExtratos } from './shared/dados-iniciais-extratos'
import { FiltroExtrato } from './shared/filtro-extrato'
import { AlterdataPHD } from '../core/util/alterdata-phd'
import { OperadoraDeMaquina } from '../pkw-data/collect/operadora-de-maquina.model'
import { OperadoraDeMaquinaService } from '../core/services/operadora-de-maquina.service'
import { Operador } from '../pkw-data/core/operador.model'
import { OperadorService } from '../core/services/operador.service'
import { EstabelecimentoService } from '../../app/estabelecimentos/shared/estabelecimento.service'

declare let $

@Component({
    selector: 'col-extratos',
    templateUrl: './extratos.component.html',
    styleUrls: ['./extratos.component.scss']
})

export class ExtratosComponent implements OnInit {
    @Input() operadoras: OperadoraDeMaquina[]

    filtro: FiltroExtrato
    empresas: Empresa[]
    empresasQVCC: EmpresaQueVendeComCartoes[]
    totalDeEstabelecimentosCarentes: number
    vendasDisabled: boolean
    recebimentosDisabled: boolean
    antecipacoesDisabled: boolean
    navegadorCompativelComExportacao: boolean
    tabTarget = '#dashboard'
    tabsComFiltro = ['#minhas-vendas', '#meus-recebimentos', '#minhas-antecipacoes']
    
    operadora: string[] = []
    
    qtdEstabelecimentosInativos = 0

    @ViewChild(ExportacaoMovimentoComponent)
    exportacaoMovimento: ExportacaoMovimentoComponent

    operador: Operador

    constructor(
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private operadoraDeMaquinaService: OperadoraDeMaquinaService,
        private operadorService: OperadorService,
        private estabelecimentoService: EstabelecimentoService
    ) {
    }

    ngOnInit() {
        this.navegadorCompativelComExportacao = !AlterdataPHD.isNavegadorDoPHD()

        this.desabilitarExtratos()

        this.route.data.subscribe(
            ({ dadosIniciais }: { dadosIniciais: DadosIniciaisExtratos }) => {
                this.empresasQVCC = dadosIniciais.todasEmpresasQVCC
                this.totalDeEstabelecimentosCarentes =
                    dadosIniciais.totalDeEstabelecimentosCarentes
                this.empresas = this.empresasQVCC.map(eQVCC => eQVCC.empresa)
            }
        )

        this.operadoraDeMaquinaService.obterIndisponiveis().subscribe((operadoras) => {
            this.operadoras = operadoras
        })

        this.operadorService.corrente.subscribe(operador => {
            this.operador = operador
        })

        const params = 'filter[situacao]=Bloqueio por múltipla autenticação&filter[situacao]=Site exigindo ação do usuário&filter[situacao]=Verificar dados de acesso'
        this.estabelecimentoService.adquirirTotalResourceCount(params).subscribe(totalResourceCount =>
            this.qtdEstabelecimentosInativos = totalResourceCount
        );
    }

    obterExtratos(filtro: FiltroExtrato) {
        this.desabilitarExtratos()
        this.filtro = filtro
    }

    habilitarVendas() {
        this.vendasDisabled = false
    }

    habilitarRecebimentos() {
        this.recebimentosDisabled = false
    }

    habilitarAntecipacoes() {
        this.antecipacoesDisabled = false
    }

    isFiltroDisabled() {
        return (
            this.vendasDisabled && this.recebimentosDisabled && this.antecipacoesDisabled
        )
    }

    selecionarTab(event: MouseEvent) {
        const $a = $(event.target)
        this.tabTarget = $a.data('target')

        $a.tab('show')
    }

    exibirFiltroForm() {
        return this.tabsComFiltro.includes(this.tabTarget)
    }

    exibirBtnRelatorio() {
        return !this.isTabSelecionada('#dashboard')
    }

    isTabSelecionada(tabId: string) {
        return this.tabTarget === tabId
    }

    abrirModalGerarRelatorio() {
        const initialState: any = {
            empresas: this.empresas,
            operadora: this.filtro.operadora,
            empresa: this.filtro.empresa,
            empresasQVCC: this.empresasQVCC,
            inicio: this.filtro.inicio,
            fim: this.filtro.fim
        }

        if (this.navegadorCompativelComExportacao && this.isTabSelecionada('#exportar-movimento')) {
            const empresa =
                this.exportacaoMovimento.exportacao.empresaQueVendeComCartoes &&
                this.exportacaoMovimento.exportacao.empresaQueVendeComCartoes.empresa
            initialState.empresa = empresa
            initialState.operadora = this.exportacaoMovimento.exportacao.operadora
            initialState.inicio = this.exportacaoMovimento.exportacao.inicio
            initialState.fim = this.exportacaoMovimento.exportacao.fim
            initialState.movimento =
                this.exportacaoMovimento.tipoDeTransacaoOpt &&
                this.exportacaoMovimento.tipoDeTransacaoOpt.tipo
        }

        this.modalService.show(GerarRelatorioModalComponent, {
            backdrop: 'static',
            initialState
        })
    }

    abrirAlertaInstabiliadadeOperadora() {
        if (this.operadoras && this.operadoras.length > 0) {
            for (let i = 0; i < this.operadoras.length; i++) {
                this.operadora[i] = this.operadoras[i].nome
            }
            return true;
        }
        return false;
    }

    private desabilitarExtratos() {
        this.vendasDisabled = true
        this.recebimentosDisabled = true
        this.antecipacoesDisabled = true
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos.component.ts